
/**
 * Generic hook for switching between authentication tabs
 * Can be reused in any application with multi-tab auth flows
 */
export const useAuthTabSwitcher = (eventName: string = 'auth-tab-switch') => {
  const switchTab = (tab: string) => {
    // Dispatch custom event to switch tabs
    const event = new CustomEvent(eventName, { detail: tab });
    window.dispatchEvent(event);
  };

  return { switchTab };
};
